import React, {Component} from 'react';
import { Button, FormControl, FormGroup, InputGroup, ControlLabel, Row, Col, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import './Stock.css';
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup';
import StockStore from '../../stores/StockStore';
import ConfirmPopup from '../../component/element/ConfirmPopup';
import CKAutocomplete from '../../component/element/CKAutocomplete';
import SearchCarButton from '../../component/element/SearchCarButton'
import WorkdocStore from '../../stores/WorkdocStore'
import SupplierPageModal from '../po/SupplierPageModal'
import Select from 'react-select'
import { Checkbox } from 'react-icheck';
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');
class StockNewInOutModal extends Component {

  constructor(props) {
    super(props)
    this.props.recordType
    this.state = ({ 
      show: false,
      showConfirm: false,
      showSupplier: false,
      showLiquid : false,
      showCar: false,      
      confirm: false,
      messageConfirm: "",
      description: "",
      request_by: "",
      response_by: "",      
      input: {car_registration_no:''},
      defaultQu: [],
      defaultCost: [],
      formValid: [],
      validState: [],
      formValidQu: [],
      validStateQu: [],
      checkBarcode: [],
      checkBarcodeIcon: [],
      set_qu: [],
      set_cost: [],
      barcodeMsg: "",
      barcodeMsgColor: "",
      customerList: [],
      stockApproverList: [],
      end_quantity:[],      
      car_registration_no_list:[],
      car_info:'',
      partTypeInfo:[],
      genExport:false
    })
    this.car_info_timestmap =  Date.now()
  }

  componentWillReceiveProps(newProps){
    if(newProps.onShow && this.props.onShow !== newProps.onShow){
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
      this.loadCarRegistrationNo()
      
      if(this.props.stockType==='part'){
        this.loadPartSeriesDetailClick()
      }

      let showLiquid = false
      let end_quantity = newProps.data.map((item,index)=>{
        
        if(item.container_unit!==undefined && item.container_unit!=='' && newProps.recordType==='export'){
          showLiquid = true
        }else{
          if(!showLiquid){
            let n = item.description.startsWith("สีผสม");
            if(n && newProps.recordType==='export'){
              showLiquid = true
            }
          }
        }
        return ''
      })
      this.setState({end_quantity:end_quantity,showLiquid:showLiquid,genExport:false})
    }

    if(newProps.recordType!==this.props.recordType){
      this.setState({formValidQu:[],validStateQu:[]})
    }
  }

  loadPartSeriesDetailClick() {
    let {data} = this.props
    let {partTypeInfo} = this.state
    let that = this
    data.forEach(function(item,index) {
      StockStore.loadPartTypeInfo(item.itemnum,item.car_cat_id,function(result) {      
        if (result.data.length>0) {
          partTypeInfo.push({
            itemnum:item.itemnum,
            old_info:result.data[0].old_info,
            original_info:result.data[0].original_info,
            similar_info:result.data[0].similar_info
          })

          if (item.partType===undefined)
            item.partType = 'original'

          if (item.partType==='old') {
            data[index].productcode = result.data[0].old_info.productcode
            data[index].barcode = result.data[0].old_info.productcode
          }else if (item.partType==='original') {
            data[index].productcode = result.data[0].original_info.productcode
            data[index].barcode = result.data[0].original_info.productcode
          }else if (item.partType==='similar') {
            data[index].productcode = result.data[0].similar_info.productcode
            data[index].barcode = result.data[0].similar_info.productcode
          }

        } else {
          partTypeInfo.push({
            itemnum:item.itemnum,
            old_info:{},
            original_info:{},
            similar_info:{}
          })
        }
        that.setState({partTypeInfo:partTypeInfo})
      })
    })  
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }  

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  loadCarRegistrationNo() {
    let {input} = this.state
    let that = this
    let car = []
    
    // if(input.car_registration_no.letngth>=2 && (Date.now() - that.car_info_timestmap)>2000){
      
      StockStore.loadCarRegistrationNo(input.car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        that.setState({car_registration_no_list:car})
        that.car_info_timestmap =  Date.now()
      })
    // }
  }

  onCarSearchSelect(e) {
    let {input,car_info} = this.state
    input.car_registration_no = e.Value  
    input.work_no =  e.work_no
    car_info = e.car_info
    this.setState({input:input,car_info:car_info})
    // this._description.focus()
  }

  onInOutHideClick(){
    this.setState({ formValid: [], validState: [], barcodeMsg: "", car_info: "" })
    this.props.onHide()
  }

  onInOutCancelClick(){

    this.setState({ input: {car_registration_no:''}, formValid: [], validState: [] })
    this.props.onCancel()
  }

  onSWTNewCustomerClick(e) {
    this.setState({ show: true })
  }

  onCustomerSelect(e) {
    let {input} = this.state
    input['request_by'] = e.name

    let {formValid} = this.state
    let {validState} = this.state
    formValid['request_by'] = ''
    validState['request_by'] = null

    this.setState({ input: input, formValid:formValid, validState:validState})
  }

  onTextChange(key, e) {
    let {input} = this.state
    input[key] = e.target.value

    let {formValid} = this.state
    let {validState} = this.state
    formValid[key] = ''
    validState[key] = null

    if (key==='shop_name') {
      input['shop_id'] = ''
    } else if (key=='car_registration_no') {
      this.loadCarRegistrationNo()
      if(e.target.value===''){
        this.setState({car_info:''})
      }
    }

    this.setState({ input: input, formValid:formValid, validState:validState })
  }

  onTextSelect(key, e) {
    let {input,car_registration_no_list} = this.state
    
    if (key==='car_registration_no') {
      let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          value = item.id
          car_info = item.car_info
          input.work_no =  item.work_no
        }  
      })
      
      input[key] = value      
      car_info = car_info
      this.setState({input:input,car_info:car_info})
      // this._description.focus()
    } else {
      input[key] = e
      this.setState({input:input})

      if (key=='request_by') {
        this.refs._response_by.onFocus()
      } else if (key==='response_by') { 
        if (this.props.recordType==='export')
          this.refs._car_registration_no.onFocus()
        // else if (this.props.recordType==='import')
        //   this._description.focus()
        // else
        //   this._description.focus()
      }  
    }  
  }

  onTextKeyPress(key,e) {
    let {messages} = this.props
    if (e.charCode === 13) {
      e.preventDefault()

      let {customerList,input} = this.state
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
        }
      })

      if (checkSearch) {
        if (key==='request_by') {
          input[key] = value
          
          this.refs._response_by.onFocus()
        } else if (key==='response_by') {
          input[key] = value

          if (this.props.recordType==='export')
            this.refs._car_registration_no.onFocus()
          // else if (this.props.recordType=='import')
          //   this._description.focus()
          // else
          //   this._description.focus()
        }
      } else {
        input[key] = ''

        this.refs.notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }

      this.setState({input:input})
    }  
  }

  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      let {input} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          input.work_no =  item.work_no         
          input.car_registration_no = item.car_registration_no              
          that.setState({input:input,car_info:item.car_info})
          // that._description.focus()
        }else{
          input.work_no = ''
          input.car_registration_no = '';
          that.setState({car_info:that.props.messages['Not Found']})
        }
      })
    }
  }

  onSearchKeyPress(e) {
    if (e.charCode === 13) {
      let {messages} = this.props
      let {input} = this.state
      let checkBarcode = []
      let checkBarcodeIcon = []

      if (e.target.value !== "") {
        for (var i=0;i<this.props.data.length;i++) {
          if (e.target.value===this.props.data[i].productcode||e.target.value==this.props.data[i].barcode) {
            var newColor = "rgba(0, 166, 90, 0.67)"
            this.state.checkBarcode[this.props.data[i].itemnum] = newColor
            this.state.checkBarcodeIcon[this.props.data[i].itemnum] = this.props.data[i].itemnum

            checkBarcode[this.props.data[i].itemnum] = newColor
            checkBarcodeIcon[this.props.data[i].itemnum] = this.props.data[i].itemnum
          }
        }
        if (checkBarcode.length > 0) {
          let msgSuccess = messages['Code']+" "+e.target.value+" "+messages['Check Correct']
          this.setState({checkBarcode:this.state.checkBarcode, checkBarcodeIcon:this.state.checkBarcodeIcon, barcodeMsg:msgSuccess, barcodeMsgColor:"rgba(0, 166, 90, 0.67)"})
        } else {
          let {formValid} = this.state
          let {validState} = this.state
          let msgError = messages['Product Code Not Found']+" "+e.target.value

          formValid['barcode'] = "formValidationError1"
          validState['barcode'] = "error"
          this.setState({formValid:formValid, validState:validState, barcodeMsg:msgError, barcodeMsgColor:"#dd4b39"})
        }

        input['barcode'] = ""
        this.setState({input:input})
      }  
    }
  }

  getStyleCheckBarcodeIcon(itemnum) {
    let {checkBarcodeIcon} = this.state

    if (checkBarcodeIcon[itemnum]===""||checkBarcodeIcon[itemnum]===undefined) {
      return "none"
    } else {
      return ""
    }
  }

  onQuantityChange(key, e) {
    let {defaultQu} = this.state
    defaultQu[key] = e.target.value

    let {formValidQu} = this.state
    let {validStateQu} = this.state
    formValidQu[key] = ''
    validStateQu[key] = null

    let {set_qu} = this.state
    set_qu['key'] = key
    set_qu['value'] = e.target.value
    this.props.quChange(set_qu)

    this.setState({ defaultQu: defaultQu, formValidQu:formValidQu, validStateQu:validStateQu })
  }

  onCostChange(key,e) {
    let {defaultCost} = this.state
    defaultCost[key] = e.target.value

    let {set_cost} = this.state
    set_cost['key'] = key
    set_cost['value'] = e.target.value
    this.props.costChange(set_cost)

    this.setState({ defaultCost: defaultCost })
  }

  setFormValid(key) {
    let {formValid} = this.state
    let {validState} = this.state
    formValid[key] = 'formValidationError1'
    validState[key] = 'error'
    this.setState({ formValid:formValid, validState:validState })
  }

  setFormValidQu(key) {
    let {formValidQu} = this.state
    let {validStateQu} = this.state
    formValidQu[key] = 'formValidationError1'
    validStateQu[key] = 'error'
    this.setState({ formValidQu:formValidQu, validStateQu:validStateQu })
  }

  onConfirmInOutSaveClick(e) {
    // let request_by = this.state.input.request_by
    // let response_by = this.state.input.response_by
    let description = this.state.input.description

    if (!description) {
      description = ""
    }

    const items = this.props.data.map((item,index)=>{
      let result = {
        itemnum: item.itemnum,
        quantity: this.props.defaultQu[item.itemnum],
        productcode:item.productcode,
        description: item.description,
        cost_per_unit: this.props.defaultCost[item.itemnum],     
      }
      if(this.props.stockType==='part'){
        result = Object.assign(result,{part_type:item.partType,cat_id:item.carInfo.series.value,car_info:item.carInfo.title})
      }
      return result
    })
    
    let postData = {}
    postData = {item:items, meta:{description:description,request_by:this.state.input.request_by, response_by:this.state.input.response_by, 
      car_registration_no:this.state.input.car_registration_no, wo:this.state.input.work_no,
      purchase_order_by:this.state.input.purchase_order_by, shop_id:this.state.input.shop_id, shop_name:this.state.input.shop_name, stock_type:this.props.stockType, record_type:this.props.recordType, added_date:this.props.date}}
    let that = this
    if (this.props.recordType === "export") { 
      StockStore.exportProduct(this.props.stockType, postData, function(result) {
        if (result.status === 'OK') {
          if(that.props.openInoutPrintAfterSubmit){
            if (process.env.NODE_ENV === "development") {
              window.open('https://demo2.bigfix.co/korat/pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
            } else{
              window.open('./pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
            }
          }
        }
      })
    } else if (this.props.recordType === "import") { 
      StockStore.importProduct(this.props.stockType, postData, function(result) {
        if (result.status === 'OK') {
          if(that.props.openInoutPrintAfterSubmit){
            if (process.env.NODE_ENV === "development") {
              window.open('https://demo2.bigfix.co/korat/pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
            } else{
              window.open('./pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
            }
          }
        } 
      })
    } else if (this.props.recordType === "request_purchase") { 
      StockStore.requestPurchaseProduct(this.props.stockType, postData, function(result) {
        if (result.status === 'OK') {
          if (process.env.NODE_ENV === "development") {
            window.open('https://demo2.bigfix.co/korat/pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
          } else{
            window.open('./pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
          }
        } 
      })
    } 

    let allData = this.props.allData
    for (var i = 0; i < items.length; i++) {
      for (var j=0; j < allData.length; j++) {
        if (allData[j].itemnum === items[i].itemnum) {
          
          if(this.props.stockType==='part'){
            let field = ''
            if(items[i].part_type==='original'){
              field = 'original_quantity'
            }else if(items[i].part_type==='similar'){
              field = 'similar_quantity'
            }else if(items[i].part_type==='old'){
              field = 'old_quantity'
            }else{
              continue;
            }

            if (this.props.recordType === "export") {
              allData[j][field] =  parseFloat(allData[j][field]) - parseFloat(items[i].quantity)
            }else if (this.props.recordType === "import") {
              allData[j][field] = parseFloat(allData[j][field]) + parseFloat(items[i].quantity)
            } else  { 
              
            }
          }else{
            var cur_qu = allData[j].quantity
            if (this.props.recordType === "export") {
              allData[j].quantity =  parseFloat(cur_qu) - parseFloat(items[i].quantity)
            }else if (this.props.recordType === "import") {  
              allData[j].quantity = parseFloat(cur_qu) + parseFloat(items[i].quantity)
            } else  { 
              
            }
          }
        }
      }
    }

    this.props.onCancel()
    this.setState({showConfirm:false, messageConfirm:"", confirm:false, input: [], car_info:''})
  }

  onInOutSaveClick() {
    let {genExport} = this.state
    let request_by = this.state.input.request_by
    let response_by = this.state.input.response_by
    let description = this.state.input.description
    
    if (!request_by) {
      this.setFormValid('request_by')
      return false
    }

    if (!response_by) {
      this.setFormValid('response_by')
      return false
    }

    if (genExport) {
      if (!description) {
        this.setFormValid('description')
        return false
      }
    }

    // const item = []
    for (var i=0;i<this.props.data.length;i++) {

      var quantity_select = parseInt(this.props.defaultQu[this.props.data[i].itemnum])
      if (this.props.recordType === "export") { 
        if (this.props.stockType==='part') {
          if (this.props.data[i].partType==='original') {
            var quantity_stock = parseInt(this.props.data[i].original_quantity)
          }else if (this.props.data[i].partType==='similar') {
            var quantity_stock = parseInt(this.props.data[i].similar_quantity)
          }else if (this.props.data[i].partType==='old') {
            var quantity_stock = parseInt(this.props.data[i].old_quantity)
          } 
        } else {
          var quantity_stock = parseInt(this.props.data[i].quantity)
        }
        if (quantity_select > quantity_stock) { 
          this.setFormValidQu(this.props.data[i].itemnum)
          return false
        }
      }

      if (quantity_select < 0) {
        this.setFormValidQu(this.props.data[i].itemnum)
        return false
      }
    }
    
    this.setState({showConfirm:true, messageConfirm:this.props.messages['Want To Save This Item']})
  }

  renderPartTable(){
    let {messages} = this.props
    return(
      <div className='display-overflow'>
        <table className="table table-responsive table-hover table-bordered-solid">
          <thead>
            <tr>
              <th style={{width: "30px"}} className="text-center">{messages['Number']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Product Code']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Model']}</th>
              <th >{messages['Item']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Original/Similar']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Quantity']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Quantity (Warehouse)']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Check Barcode']}</th>
              <th className="text-center">{messages['Delete']} ?</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th style={{width: "30px"}} className="text-center">{messages['Number']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Product Code']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Model']}</th>
              <th >{messages['Item']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Original/Similar']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Quantity']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Quantity (Warehouse)']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Check Barcode']}</th>
              <th className="text-center">{messages['Delete']} ?</th>
            </tr>
          </tfoot>
          <tbody>
            { this.renderPartRowData() }  
          </tbody>
        </table>
      </div>  
    );
  }

  renderTable() {
    let {recordType} = this.props
    let {stockType,messages} = this.props
    let {showLiquid} = this.state
    if(stockType==='part'){
      return this.renderPartTable()
    }

    let quantityTitle = showLiquid?(<span>{messages['User']}/<br/>{messages['Quantity']}</span>):messages['Quantity']
    let quantityStock = showLiquid?(<span>{messages['Weight']}<br/>({messages['Latest']})</span>):(<span>{messages['Quantity']}<br/>({messages['Warehouse']})</span>)
    return(
      <div className='display-overflow'>
        <table className="table table-responsive table-hover table-bordered-solid">
          <thead>
            <tr>
              <th style={{width: "30px"}} className="text-center">{messages['Number']}</th>
              <th style={{width: "120px"}} className="text-center">{messages['Product Code']}</th>
              <th >{messages['Item']}</th>
              <th style={{width: "100px",display:(!showLiquid)?'none':''}} className="text-center" >{messages['Weight Scale']}</th>
              <th style={{width: "100px"}} className="text-center">{quantityTitle}</th>              
              <th style={{width: "100px"}} className="text-center">{quantityStock}</th>
              <th style={{width: "150px",display:(recordType==='export'?'none':'')}} className="text-center">{messages['Cost']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Check Barcode']}</th>
              <th style={{width: "30px"}} className="text-center">{messages['Delete']}</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th style={{width: "30px"}} className="text-center">{messages['Number']}</th>
              <th style={{width: "120px"}} className="text-center">{messages['Product Code']}</th>
              <th >{messages['Item']}</th>
              <th style={{width: "100px",display:(!showLiquid)?'none':''}} className="text-center" >{messages['Weight Scale']}</th>
              <th style={{width: "100px"}} className="text-center">{quantityTitle}</th>              
              <th style={{width: "100px"}} className="text-center">{quantityStock}</th>
              <th style={{width: "150px",display:(recordType==='export'?'none':'')}} className="text-center">{messages['Cost']}</th>
              <th style={{width: "100px"}} className="text-center">{messages['Check Barcode']}</th>
              <th style={{width: "30px"}} className="text-center">{messages['Delete']}</th>
            </tr>
          </tfoot>
          <tbody>
            { this.renderRowData() }  
          </tbody>
        </table>
      </div>  
    );
  }

  onDeleteClick(itemnum, e) {
    this.props.onDelete(itemnum)
  }

  onPartTypeChange(index,value){
    let {partTypeInfo} = this.state
    let {data} = this.props
    if(this.props.onPartTypeChange!==undefined) { 
      this.props.onPartTypeChange(index,value)

      partTypeInfo.forEach(function(item,i) {
        if (item.itemnum===data[index].itemnum) {
          if (value.value==='old') {
            data[index].productcode = item.old_info.productcode
            data[index].barcode = item.old_info.productcode
          }else if (value.value==='original') {
            data[index].productcode = item.original_info.productcode
            data[index].barcode = item.original_info.productcode
          }else if (value.value==='similar') { 
            data[index].productcode = item.similar_info.productcode
            data[index].barcode = item.similar_info.productcode
          }
        }
      })
    }
  }

  onCustomerClick() {
    this.setState({ showSupplier: true })
  }

  onSupplierPageSelect(item){
    let {input} = this.state
    input['shop_id'] = item.shop_id
    input['shop_name'] = item.name
    this.setState({input:input})
  }

  onEndQuantityChange(itemnum,index,e){
    let {end_quantity} = this.state
    let {data} = this.props
    end_quantity[index] = e.target.value
    let usedQuantity = data[index].quantity*1 - end_quantity[index]*1 
    let eQ = {target:{value:usedQuantity}}

    this.onQuantityChange(itemnum,eQ)

    this.setState({end_quantity:end_quantity})
  }

  getStockQuantity(item){
    if(item.partType==='original'){
      return item.original_quantity
    }else if(item.partType==='similar'){
      return item.similar_quantity
    }else if(item.partType==='old'){
      return item.old_quantity
    }else{
      return ""
    }
  }

  renderPartRowData() {
    let {messages} = this.props
    if (this.props.data.length === 0) {
      return(<tr><td colSpan={9}>{this.props.messages['No Data']}</td></tr>)
    } else {
      return( 
        this.props.data.map((item, index) => {
          return(
            <tr key={index} style={{backgroundColor: this.state.checkBarcode[item.itemnum]}}>
              <td className="text-center">{index+1}</td>
              <td className="text-center">{item.productcode}</td>
              <td className="text-center">{item.car_detail===undefined?item.carInfo.title:item.car_detail}</td>
              <td>{ item.description }</td>
              <td>
                <Select 
                  clearable={false}
                  value={item.partType===undefined?'original':item.partType}
                  options={[{label:messages['Original'],value:'original'},{label:messages['Similar'],value:'similar'},{label:messages['Old'],value:'old'}]}
                  onChange={this.onPartTypeChange.bind(this,index)}
                />
              </td>
              <td className="text-center">
                <FormGroup
                  controlId={this.state.formValidQu[item.itemnum]}
                  validationState={this.state.validStateQu[item.itemnum]}
                >
                  <FormControl type="number" value={ this.props.defaultQu[item.itemnum] }  onChange={ this.onQuantityChange.bind(this, item.itemnum) } className="text-center" />
                </FormGroup>
              </td>  
              <td className="text-center">
                <FormControl type="text" value={ this.getDecimal(this.getStockQuantity(item)) } readOnly="" className="input-dark text-center" />
              </td>
              <td className="text-center">
                <FontAwesome name='check' style={{display:this.getStyleCheckBarcodeIcon(item.itemnum)}} />
              </td>
              <td className="text-center" onClick={this.onDeleteClick.bind(this, item.itemnum)}>
                <FontAwesome className="color-red" name='times-circle' />
              </td>    
            </tr>  
          ) 
        })
      )
    }  
  }

  getDecimal(number) {
    if (isNaN(number)) {
      return 0
    } else if (number==="") { 
      return ""
    } else {
      return parseFloat(number).toFixed(2) * 1
    }
  }

  renderRowData() {
    let {recordType,messages} = this.props
    let {showLiquid,end_quantity} =  this.state
    if (this.props.data.length === 0) {
      return(<tr><td colSpan={7}>{messages['No Data']}</td></tr>)
    } else {
      return(
        this.props.data.map((item, index) => {
          return(
            <tr key={index} style={{backgroundColor: this.state.checkBarcode[item.itemnum]}}>
              <td className="text-center">{ index + 1 }</td>
              <td className="text-center">{ item.productcode }</td>
              <td>{ item.description }</td>
              <td className="text-center" style={{display:(!showLiquid)?'none':''}}>
                <FormControl type="text" value={ end_quantity[index] } onChange={this.onEndQuantityChange.bind(this,item.itemnum,index)}  className=" text-center" />
              </td>
              <td className="text-center">
                <FormGroup
                  controlId={this.state.formValidQu[item.itemnum]}
                  validationState={this.state.validStateQu[item.itemnum]}
                >
                  <FormControl type="number" step="0.5" value={ this.props.defaultQu[item.itemnum] }  onChange={ this.onQuantityChange.bind(this, item.itemnum) } className="text-center" />
                </FormGroup>
              </td>                
              <td className="text-center">
                <FormControl type="text" value={ this.getDecimal(item.quantity) } readOnly="" className="input-dark text-center" />
              </td>
              <td className="text-center" style={{display:(recordType=='export'?'none':'')}}>
                <FormControl type="text" value={ this.props.defaultCost[item.itemnum] } onChange={this.onCostChange.bind(this, item.itemnum)} className="text-center" />
              </td>
              <td className="text-center">
                <FontAwesome name='check' style={{display:this.getStyleCheckBarcodeIcon(item.itemnum)}} />
              </td>
              <td className="text-center" onClick={this.onDeleteClick.bind(this, item.itemnum)}>
                <FontAwesome className="color-red" name='times-circle' />
              </td>    
            </tr>  
          ) 
        })
      )
    }  
  }

  onLiquidChange(e) {
    let {showLiquid} = this.state
    if (showLiquid) {
      showLiquid = false
    } else {
      showLiquid = true
    }
    this.setState({showLiquid:showLiquid})
  }

  onGenExportChange() {
    let {genExport} = this.state
    if (genExport) {
      genExport = false
    } else {
      genExport = true
    }
    this.setState({genExport:genExport})
  }

  renderCustomerButton(){
    if (this.props.stockType === "genpart" && this.props.recordType === "export") { 
      return (
        <InputGroup.Addon className="btn"
        onClick={ this.onSWTNewCustomerClick.bind(this) }
      >
        <FontAwesome name='plus' />
      </InputGroup.Addon>
      )
    }else{
      return ('')
    }
  }

  render(){
    let {stockType,recordType,messages} = this.props
    let showCbLiquid = false
    if(stockType==='color' || stockType==='officemate'){
      if(recordType==='export'){
        showCbLiquid = true
      }
    }
    return (
      <div>
        <Modal bsSize="large" show={this.props.onShow} onHide={this.onInOutHideClick.bind(this)} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>
              {messages['Create']}{this.props.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div  className='stock-inout-modal'>
            <form >
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Date']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" className="input-dark" value={ this.props.date } />
                  </FormGroup>
                </Col>
              </Row>
              
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.request_by }
                    validationState={ this.state.validState.request_by }
                  >
                    <ControlLabel>{ this.props.titleTextInOut }<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={ this.state.formValid.request_by }
                    validationState={ this.state.validState.request_by }
                  >
                    <InputGroup style={{width: '100%'}}>
                        <CKAutocomplete
                          items={this.state.customerList}
                          value={this.state.input.request_by}
                          onChange={this.onTextChange.bind(this, 'request_by')}
                          onSelect={this.onTextSelect.bind(this, 'request_by')}
                          onKeyPress={this.onTextKeyPress.bind(this, 'request_by')}
                        />
                        {this.renderCustomerButton()}
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.response_by }
                    validationState={ this.state.validState.response_by }
                  >
                    <ControlLabel>{messages['Approvers']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={ this.state.formValid.response_by }
                    validationState={ this.state.validState.response_by }
                  >
                    <CKAutocomplete
                      top={'-34px'}
                      items={this.state.customerList}
                      value={this.state.input.response_by}
                      onChange={this.onTextChange.bind(this, 'response_by')}
                      onSelect={this.onTextSelect.bind(this, 'response_by')}
                      onKeyPress={this.onTextKeyPress.bind(this, 'response_by')}
                      ref='_response_by'
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row style={{display:(this.props.recordType==='request_purchase'?'':'none')}}>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Purchaser']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={this.state.input.purchase_order_by} onChange={this.onTextChange.bind(this, 'purchase_order_by')} />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Shop']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon><FontAwesome name='user' /></InputGroup.Addon>
                      <FormControl value={this.state.input.shop_name} onChange={this.onTextChange.bind(this, 'shop_name')} />
                      <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus' /></InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              
              <Row style={{display:this.props.recordType==='export'?'':'none'}}>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Car Registration']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                      <InputGroup>
                        <CKAutocomplete     
                          disabled={this.state.genExport}                     
                          items={this.state.car_registration_no_list}
                          value={this.state.input.car_registration_no}
                          onKeyPress={this.onSearchCarKeyPress.bind(this)}
                          onChange={this.onTextChange.bind(this, 'car_registration_no')}
                          onSelect={this.onTextSelect.bind(this, 'car_registration_no')}
                          ref='_car_registration_no'
                        />
                        <InputGroup.Addon className="btn" onClick={()=>this.setState({showCar:true})} style={{pointerEvents:this.state.genExport?'none':'',backgroundColor:this.state.genExport?'#eee':''}}>
                          <FontAwesome name='plus' />
                        </InputGroup.Addon>
                      </InputGroup>  
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Checkbox
                      onChange={this.onGenExportChange.bind(this)}
                      checked={this.state.genExport}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"
                      label={' '+messages['General/Other']}
                    >
                    </Checkbox>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.description }
                    validationState={ this.state.validState.description }
                  >
                    <ControlLabel>{messages['Description']}{this.state.genExport?<span className="color-red">*</span>:''}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup
                    controlId={ this.state.formValid.description }
                    validationState={ this.state.validState.description }
                  >
                    <FormControl inputRef={(input) => { this._description = input }} type="text" placeholder="" value={ this.state.input.description } onChange={ this.onTextChange.bind(this, 'description') } />
                  </FormGroup>
                </Col>
                <Col md={2} style={{display:(showCbLiquid)?'':'none'}}>
                  <Checkbox
                    onChange={this.onLiquidChange.bind(this)}
                    checked={this.state.showLiquid}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' '+messages['Scale']}
                  >
                  </Checkbox>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.barcode }
                    validationState={ this.state.validState.barcode }
                  >
                    <ControlLabel>{messages['Barcode']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={ this.state.formValid.barcode }
                    validationState={ this.state.validState.barcode }
                  >
                    <FormControl type="text" placeholder="" value={ this.state.input.barcode } 
                    onChange={ this.onTextChange.bind(this, 'barcode') } 
                    onKeyPress={this.onSearchKeyPress.bind(this)} />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <p style={{color:this.state.barcodeMsgColor}}>{this.state.barcodeMsg}</p>
                </Col>
              </Row>                            
              { this.renderTable() }
            </form>      
            </div>
          </Modal.Body>  
          <Modal.Footer>
            <Button className="btn-default" onClick={ this.onInOutHideClick.bind(this) }>
              <FontAwesome name='plus' /> {messages['Add Item']}
            </Button>
            <Button className="btn-primary" onClick={ this.onInOutSaveClick.bind(this) }>
              <FontAwesome name='save' /> {messages['Save']}
            </Button>
            <Button className="btn-default" onClick={ this.onInOutCancelClick.bind(this) }>
              <FontAwesome name='remove' /> {messages['Cancel']}
            </Button>            
          </Modal.Footer>      
        </Modal>
        <SWTNewCustomerPopup 
          show={this.state.show} 
          onHide={()=>{this.setState({show:false})}}
          onSelect={this.onCustomerSelect.bind(this)}
        />
        <SupplierPageModal show={this.state.showSupplier} onHide={()=>{this.setState({showSupplier:false})}}
          onSelect={this.onSupplierPageSelect.bind(this)}
        />
        <SearchCarButton
          show={this.state.showCar}
          onHide={()=>{this.setState({showCar:false})}}
          onSelect={this.onCarSearchSelect.bind(this)}
        />
        <ConfirmPopup
          show={this.state.showConfirm}
          message={this.state.messageConfirm}
          onConfirm={this.onConfirmInOutSaveClick.bind(this)}
          onHide={()=>{this.setState({showConfirm:false})}}
        >
        </ConfirmPopup>
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

StockNewInOutModal.defaultProps = {
  openInoutPrintAfterSubmit : true
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockNewInOutModal}),null,null,{withRef:true},
)(StockNewInOutModal);





// WEBPACK FOOTER //
// ./src/view/stock/StockNewInOutModal.js